import React from 'react';
import { useTranslation } from 'react-i18next';

const ServiceTicketsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">客服工单</h1>
        <p className="text-gray-600 mt-2">用于统一处理客户服务工单</p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-gray-700">
          {t('common.comingSoon', '功能建设中，后续将补充具体业务逻辑。')}
        </div>
      </div>
    </div>
  );
};

export default ServiceTicketsPage;
